
import { EventResponse } from '@/model/Event';
import { Sheet } from '@/model/Sheet';
import { Component, Emit, Prop } from 'vue-property-decorator';
import CardInnerLayout from '@/components/layout/CardInnerLayout.vue';
import EventIcon from '@/components/event/EventIcon.vue';
import { dateFormatOptions } from '@/lib/date-util';
import CustomModal from '@/components/modal/CustomModal.vue';
import CreateEventModal from '@/active-components/dashboard/CreateEventModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import ToastMixin from '@/mixins/ToastMixin';
import { mixins } from 'vue-class-component';
import ToastVariant from '@/model/enums/toast/toast-variant';

@Component({
    components: {
        CardInnerLayout,
        EventIcon,
        CustomModal,
        CreateEventModal,
        ConfirmationModal,
    },
})
export default class DashboardCard extends mixins(ToastMixin) {
    @Prop() item!: Sheet | EventResponse;

    @Prop({ type: Boolean }) icons!: boolean;

    @Emit()
    onUpdateSuccess(): void {
        this.showToast(
            this.$t(
                'dashboard.events.notification.successful-update',
            ).toString(),
            this.$t('dashboard.events.notification.title').toString(),
            ToastVariant.SUCCESS,
        );
        this.$bvModal.hide(`update-modal-${this.item.id}`);
    }

    onDuplicateSuccess(createdEvent?: EventResponse): void {
        this.$bvModal.hide(`duplicate-modal-${this.item.id}`);
        if (createdEvent?.id) {
            this.$router.push({
                name: 'Event',
                params: { id: createdEvent.id.toString() },
            });
        }
    }

    @Emit()
    deleteEvent(): void {
        // delete event
    }

    get displayDate(): string | undefined {
        if (this.icons) {
            return this.formatDate(this.item.startDate);
        }

        const sheet = this.item as Sheet;
        return this.formatDate(sheet.createdAt ?? sheet.startDate);
    }

    get cardProjectName(): string {
        if (this.icons) {
            return (this.item as EventResponse).projectName;
        }

        return (this.item as Sheet).eventProjectName;
    }

    get cardEventName(): string {
        if (this.icons) {
            return (this.item as EventResponse).name;
        }

        return (this.item as Sheet).name ?? '';
    }

    formatDate(date?: Date | null): string | undefined {
        return date?.toLocaleDateString(this.$i18n.locale, dateFormatOptions);
    }

    onClose(type: 'update' | 'duplicate', itemId: number): void {
        this.$bvModal.hide(`${type}-modal-${itemId}`);
    }
}
